<div class="row title">
    <h3>Dashboard / Portfolio Data / <span>Add New Segment</span></h3>
  </div>
  
  
  <div class="row justify-content-center internalPageBodyContent">
      <div class="col-md-10 col-md-offset-2 mb-3">
          <button class="button button_emi" (click) = "back()"> BACK TO PORTFOLIO DATA</button>
          <div class="alert alert-success text-center mt-2" *ngIf="successMessage">{{successMessage}}</div>
          <div class="alert alert-danger text-center mt-2" *ngIf="errorMessage">{{errorMessage}}</div>
          <div class="card">
              <div class="card-content my-2 mx-2">
                  <div class="tab-content">
                      <div class="tab-pane active">
                          <form [formGroup]="createPortfolioForm" (ngSubmit)="onSubmit(createPortfolioForm.value); createPortfolioForm.reset();" class="form-horizontal">
                              <fieldset formArrayName="portfolio">
                                  <div class="row" *ngFor="let item of getJobAttributes(createPortfolioForm); let i=index" [formGroup]="item">
                                      <div class="col-sm-12">
                                          <i class="fa fa-minus-circle remove_button" (click)="createPortfolioForm.get('portfolio').removeAt(i)"></i>
                                      </div>
                                      <div class="col-md-6">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Segment<span class="astric">*</span></label>
                                              <!-- <input type="text" class="form-control" [attr.id]="'segment'+i" formControlName="segment"> -->
                                              <select class="form-control custom-select"  [attr.id]="'segment'+i" formControlName="segment" (change)="firstDropDownChanged($event.target.value,i)">
                                                  <option value="">Select Segment</option>
                                                  <option value="Home">Home</option>
                                                  <option value="Office">Office</option>
                                              </select>
                                          </div>
                                      </div>
                                       <div class="col-md-6">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Space<span class="astric">*</span></label>
                                             <!--  <input type="text" class="form-control" [attr.id]="'space'+i" formControlName="space"> -->
                                             <select class="form-control" [attr.id]="'space'+i" formControlName="space" (change)="spaceDropDownChanged($event.target.value,i)">
                                                  <option value="">Select Space</option>
                                                 <option *ngFor="let v of spaces[i]" value="{{v}}">
                                                     {{v}}
                                                 </option>
                                             </select>
                                          </div>
                                      </div>
  <!--                                     <div class="col-md-2 td-actions">
                                          <i class="fa fa-minus-circle pull-right removeIcon mr-2" (click)="createPortfolioForm.get('portfolio').removeAt(i)" style=""></i> -->
                                          <!-- <button type="button" class="btn" (click)="createPortfolioForm.get('portfolio').removeAt(i)">-</button> -->
  <!--                                     </div> -->
  
  
                                      <div class="col-md-6" [attr.id]="themeFlag[i]" *ngIf="themeFlag[i]">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Theme<span class="astric">*</span></label>
                                              <!-- <input type="text" class="form-control" [attr.id]="'theme'+i" formControlName="theme"> -->
                                               <select class="form-control" [attr.id]="'theme'+i" formControlName="theme" (change)="themeDropDownChanged($event.target.value,i)">
                                                  <option value="">Select Theme</option>
                                                 <option *ngFor="let v of themes[i]" value="{{v}}">
                                                     {{v}}
                                                 </option>
                                             </select>
                                          </div>
                                      </div>
  
                                      <div class="col-md-6" [attr.id]="lifestageFlag[i]">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Lifestage<span class="astric">*</span></label>
                                              <select class="form-control text-capitalize" [attr.id]="'lifestage'+i" formControlName="lifestage">
                                                  <option value="">Select Lifestage</option>
                                                  <option class="text-capitalize" *ngFor="let v of lifeStage" value="{{v.name}}">{{transform(v.name)}}</option>
                                              </select>
                                          </div>
                                      </div>
                                      <div class="col-md-6" [attr.id]="elementsFlag[i]" *ngIf="elementsFlag[i]">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Elements</label>
                                              <select class="form-control" [attr.id]="'element'+i" formControlName="element">
                                                  <option value="">Select Element</option>
                                                  <option *ngFor="let v of elements[i]" value="{{v}}">{{v}}</option>
                                              </select>
                                          </div>
                                      </div>
                                      <div class="col-md-6">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">EMI</label>
                                              <span class="astric">*</span>
                                              <input type="number" min=0 class="form-control" placeholder="Enter EMI" [attr.id]="'price_cents'+i" formControlName="price_cents">
                                          </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group label-floating" >
                                            <label class="control-label">Space Area</label>
                                            <input type="number" min=0 class="form-control" placeholder="Enter Space Area" formControlName="space_area">
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group label-floating" >
                                            <label class="control-label">Space Shape</label>
                                            <input type="text" min=0 class="form-control" placeholder="Enter Space Shape" formControlName="space_shape">
                                        </div>
                                    </div>
  
                                      <div class="col-md-6">
                                          <div class="form-group label-floating">
                                              <label class="control-label">Select Main Image<span class="astric">(Single Image is Allowed)</span><span class="astric">*</span></label>
                                              <input type="file" class="form-control border-0" (change)="onChange($event,i)" name="attachment_file" [attr.id]="'attachment_file'+i" formControlName="attachment_file">
                                          </div>
                                          <div id="errormsgblock">
                                              <small [attr.id]="'errorsize'+i" class="text-danger"></small>
                                              <small [attr.id]="'errorresolution'+i" class="text-danger"></small>
                                          </div>
                                          <!-- <p>Note* - Image dimension should be 1010 <i class="fa fa-times" aria-hidden="true"></i> 583</p> -->
  
                                      </div>
                                      <!--User Story Title-->
                                      <div class="col-md-6">
                                        <div class="form-group label-floating" >
                                            <label class="control-label">User Story Title</label>
                                            <input type="text" class="form-control" placeholder="Enter User Story Title" [attr.id]="'user_story_title'+i" formControlName="user_story_title">
                                        </div>
                                    </div>
                                      
                                      <!--Secondary Images-->
                                      <div class="col-md-12">
                                        <div class="form-group label-floating">
                                            <label class="control-label">Select Secondary Images<span class="astric">(Max 5 Images are Allowed)</span></label>
                                            <input type="file" multiple="" class="form-control border-0" (change)="onChangeImage($event,i)" name="contents" formControlName="contents">
                                        </div>
                                        <!-- <div id="errormsgblock">
                                            <small [attr.id]="'errorsize'+i" class="text-danger"></small>
                                            <small [attr.id]="'errorresolution'+i" class="text-danger"></small>
                                        </div> -->
                                    </div>
                                    <!-- <img *ngFor='let url of images'  [src]="url" height="150" width="200px" style="margin: 3px;"> <br/> -->
                                    <!-- <ng-container *ngFor="let url of imageName"> -->
                                     <div class="col-md-12">   
                                    <ng-container *ngFor="let url of imageName">

                                      <span class="mr-2" style="color: #8d0528">{{url}}</span> 
                                      </ng-container>
                                     </div>
                                      <!-- </ng-container> -->

                                     
                                   
                                    
                                      <div class="col-md-6">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Preset Number</label>
                                              <input type="text" class="form-control" placeholder="Enter Preset Number" formControlName="preset_number">
                                          </div>
                                      </div>
                                      <!--Seelct Preset-->
                                      <div class="col-md-6">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Select Preset Type</label>
                                              <select class="form-control" formControlName="preset_type" (change)="presetDropDownChanged($event.target.value)">
                                              <option value="">Select Preset</option>
                                              <option value="Basic">Basic</option>
                                              <option value="Advanced">Advanced</option>
                                              <option value="Plus">Plus</option>
                                          </select>
                                          </div>
                                      </div>
  
                                <!--Select City-->
                                <div class="col-md-6">
                                  <div class="form-group label-floating">
                                      <label class="control-label"> Search For City</label>
                                      <ng-select
                                  placeholder="Search For City"
                                  class=""
                                  formControlName="city_select"
                                  [ngModel]="city_value"
                                  (change)="getscityList($event)"
                                  (keyup)="searchCity($event)"
                                        >
                              <ng-option *ngFor="let city of city_list" [value]="city.name">{{
                              city.name | titlecase
                              }}</ng-option>
                              
                          </ng-select>
        
                                  </div>
                              </div>
  
                              <!-- Select Apartment-->
                              <div class="col-md-6">
                                  <div class="form-group label-floating">
                                      <label class="control-label"> Search For Apartments</label>
                                      <ng-select
                                  placeholder="Search For Apartment"
                                  class=""
                                  formControlName="apartment_select"
                                  (change)='getselectedbuilding($event)'
                                  [ngModel]="selectedBuilding"
                                  (keyup)="searchSociety($event)"
                                        >
                                        <ng-option *ngFor='let build of societyList' [value]="build.attributes.unid">{{build.attributes.apartment_name}}</ng-option>
                              
                          </ng-select>
        
                                  </div>
                              </div>
  
                              <!--Select Flat size/type-->
                              <!-- <ng-container *ngIf="flatsize && city_list && societyList && societyList.length > 0"> -->
                              <div class="col-md-6">
                                  <div class="form-group label-floating">
                                      <label class="control-label">Select Flat Type/ Size</label>
                                      <select
                                      class="form-control"
                                      id=""
                                      (change)="getselectedbuildingtypes($event)"
                    >
                    <option [ngValue]="null">Select Flat-Type</option>
                      <option
                        *ngFor="let types of flatsize"
                        [value]="types"
                      >
                        {{ types }}
                      </option>
                    </select>
                                      </div>
                              </div>
                              <!-- </ng-container> -->

                         <!--Select Varient Id-->     
                              <div class="col-md-6">
                                <div class="form-group label-floating">
                                    <label class="control-label">Select Variant Id</label>
                                    <select
                                    class="form-control"
                                    id=""
                                    (change)="isAllVarient($event)"
                  >
                    <option [ngValue]="null">Select Variant</option>
                    <option
                      *ngFor="let types of varientId"
                      [value]="types.id"
                    >
                      {{ types.variant_id }}
                    </option>
                  </select>
                                    </div>
                            </div>
  
                                      <div class="col-md-6">
                <div class="form-group label-floating">
                <!-- <label class="control-label"> Search For BOQ Reference Number</label>
                <ng-select
                placeholder="Search and Select BOQ"
                  class=""
                  formControlName="boq_number"
                  [ngModel]="boq_reference_number_value"
                  (change)="getsBOQnumber($event)"
                  (keyup)="searchBOQ($event)"
                >
                  <ng-option *ngFor="let build of boq_dropdown" [value]="build.reference_number">{{
                    build.reference_number
                  }}</ng-option>
                  
                </ng-select> -->
                <label class="control-label"> Search For BOQ Reference Number</label>
                <ng-select
            placeholder="Search and Select BOQ"
            class=""
            formControlName="boq_number"
            [ngModel]="boq_reference_number_value"
            (change)="getsBOQnumber($event)"
            (keyup)="searchBOQ($event)"
                  >
                  <ng-option *ngFor="let build of boq_dropdown" [value]="build.reference_number">{{
                      build.reference_number
                    }}</ng-option>
        
    </ng-select>
                
                                          </div>
                                      </div>
                                      <ng-container *ngIf="BOQAmount">
                                          <div class="col-md-6">
                                              <div class="form-group label-floating" >
                                                  <label class="control-label">BOQ Value</label>
                                                  <input type="text" class="form-control" formControlName="boq_value" disabled [value]="BOQAmount">
                                              </div>
                                          </div>
                                        </ng-container>
  
                                     <!--  <div class="col-md-6">
                                         <div class="form-group label-floating">
                                              <label class="control-label"> Portfolio Data</label>
                                              <textarea  class="form-control" formControlName="portfolio_data" [attr.id]="'portfolio_data'+i" placeholder="Enter Portfolio Data" rows="1"></textarea>
                                          </div>
                                      </div> -->
                                      <div class="col-md-12">
                                          <div class="form-group label-floating" >
                                              <label class="control-label">Description</label>
                                              <textarea rows="3" class="form-control" placeholder="Enter Description" [attr.id]="'description'+i" formControlName="description"></textarea>
                                              <!-- <input type="" min=0 class="form-control" placeholder="Enter Price" [attr.id]="'description'+i" formControlName="description">-->
                                          </div>
                                      </div>
  
                                      <div class="col-md-12">
                                          <div class="form-group label-floating" >
                                          <ul class="ks-cboxtags" id="myUL">
                                              <li *ngFor="let item of other_elements[i];let j = index">
                                                  <span>
                                                    <input type="checkbox" id="{{item.attributes.item_name+i+j}}"
                                                       value="{{item.attributes.id}}" (change)="isAllSelected($event,i)">
                                                    <label class="text-capitalize" for="{{item.attributes.item_name+i+j}}">{{item.attributes.item_name}}</label>
                                                  </span>
                                                  <!-- <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                                                    <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                                                      (change)="isAllSelected($event)" value="{{item.name}}">
                                                    <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                                                  </span> -->
                                                </li>
                                                </ul>
                                          </div>
                                      </div>
                                  </div>
  
  
                              </fieldset>
                              <a (click)="pushJobAttributes(createPortfolioForm)" class="addIcon"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another New Segment Image</a>
                              <button type="submit" class="button pull-right" [disabled]="createPortfolioForm?.invalid">Submit</button>
  
  
                          </form>
                              <!-- <h6 class="mt-3">FormGroup Model (<code>createPortfolioForm.value</code>)</h6>
                              <div><pre><code>{{ createPortfolioForm?.value | json }}</code></pre></div> -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
  
  </div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/portfolio/portfolio.component.html